var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.679 10.495C7.77709 11.184 6.65008 11.5933 5.42749 11.5933C2.46665 11.5933 0.0664062 9.19302 0.0664062 6.23218C0.0664062 3.27133 2.46665 0.871094 5.42749 0.871094C8.38834 0.871094 10.7886 3.27133 10.7886 6.23218C10.7886 7.42949 10.3961 8.53512 9.73273 9.42744L13.9254 13.6201C14.2182 13.913 14.2182 14.3878 13.9254 14.6807C13.6325 14.9736 13.1576 14.9736 12.8647 14.6807L8.679 10.495ZM9.28857 6.23218C9.28857 8.3646 7.55991 10.0933 5.42749 10.0933C3.29507 10.0933 1.56641 8.3646 1.56641 6.23218C1.56641 4.09976 3.29507 2.37109 5.42749 2.37109C7.55991 2.37109 9.28857 4.09976 9.28857 6.23218Z",
    fill: "#919397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyIcon);
export default __webpack_public_path__ + "static/media/magnify-icon.1b8a0de9aa518bd8dc5f140a1148e0a1.svg";
export { ForwardRef as ReactComponent };